import { ALL_STATUSES, STATUS_STYLE } from "../constants";
import type { Status } from "../types";

interface Props {
  status: Status;
  onChange?: (next: Status) => void;
  lg?: boolean;
}

export function StatusBadge({ status, onChange, lg }: Props) {
  const s = STATUS_STYLE[status] ?? STATUS_STYLE["Not Started"];

  if (!onChange) {
    return (
      <span
        className={`inline-flex items-center gap-1.5 rounded-full font-medium ${
          lg ? "px-3 py-1 text-sm" : "px-2.5 py-0.5 text-xs"
        } ${s.badge}`}
      >
        <span className={`w-1.5 h-1.5 rounded-full shrink-0 ${s.dot}`} />
        {status}
      </span>
    );
  }

  return (
    <div className="relative inline-block">
      <select
        value={status}
        onChange={(e) => onChange(e.target.value as Status)}
        className={`inline-flex items-center rounded-full font-medium cursor-pointer appearance-none pr-5 pl-5 ${
          lg ? "py-1 text-sm" : "py-0.5 text-xs"
        } ${s.badge} status-select`}
        style={{
          backgroundImage: `url("data:image/svg+xml,%3Csvg xmlns='http://www.w3.org/2000/svg' width='10' height='6'%3E%3Cpath d='M0 0l5 6 5-6z' fill='%2394a3b8'/%3E%3C/svg%3E")`,
          backgroundRepeat: "no-repeat",
          backgroundPosition: "right 6px center",
        }}
      >
        {ALL_STATUSES.map((st) => (
          <option key={st} value={st}>
            {st}
          </option>
        ))}
      </select>
      <span
        className={`absolute left-2.5 top-1/2 -translate-y-1/2 w-1.5 h-1.5 rounded-full shrink-0 pointer-events-none ${s.dot}`}
      />
    </div>
  );
}
